<template>
  <app-header :is-admin="true"/>
  <router-view></router-view>
  <admin-nav/>
</template>

<script>
import {mapActions} from 'vuex'
import AppHeader from "./AppHeader";
import AdminNav from "./Admin/AdminNav";

export default {
    name: 'AdminApp',
    components: {
        AdminNav,
        AppHeader
        },
    props: {},

    data() {
      return {}
    },
    created() {
        this.getUserInfo();
    },
    mounted() {
        let current = this.$router.currentRoute.value.path;
        if (current.replace(/[/]/g, '') === 'manage') {
            this.$router.push('/manage/requests')
        }

    },
    methods: {
        ...mapActions('user', [
            'getUserInfo',
        ]),
    },



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
